export default {
    photographers: {
        list: [],
        edit: { photographer: {} },
        modal: {
            imageEditorFirms: [],
            blockedForFirms: [],
            sellers: [],
            regions: [],
            agreements: [],
            availableLanguages: []
        }
    }
};
